export enum ETool {
    View,
    Pen,
    Eraser,
    Save
}
